import { toast } from "sonner";
import { API, imgUrl } from "./api";

const loadImg = (src) => new Promise((res) => { const im = new Image(); im.crossOrigin = "anonymous"; im.onload = () => res(im); im.onerror = () => res(null); im.src = src; });
const rr = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); };
const inr = (n) => "₹" + Number(n).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const METHOD = { upi: "UPI", bank: "Bank Transfer", gpay: "GPay Number", qr: "UPI QR" };

/** Branded payout receipt (1080x1350) → PNG data URL. */
export async function renderReceiptCard(w) {
  let logo = null;
  try { const cfg = await (await fetch(`${API}/config`)).json(); if (cfg?.app_logo) logo = await loadImg(imgUrl(cfg.app_logo)); } catch {}
  const W = 1080, H = 1350, cv = document.createElement("canvas"); cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  const bg = ctx.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, "#052e16"); bg.addColorStop(0.5, "#064e3b"); bg.addColorStop(1, "#0f172a");
  ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
  const glow = ctx.createRadialGradient(W / 2, 640, 40, W / 2, 640, 480); glow.addColorStop(0, "rgba(52,211,153,.35)"); glow.addColorStop(1, "rgba(52,211,153,0)");
  ctx.fillStyle = glow; ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#fbbf24"; ctx.lineWidth = 10; rr(ctx, 30, 30, W - 60, H - 60, 48); ctx.stroke();
  if (logo) { ctx.save(); rr(ctx, W / 2 - 80, 80, 160, 160, 36); ctx.clip(); ctx.drawImage(logo, W / 2 - 80, 80, 160, 160); ctx.restore(); }
  ctx.textAlign = "center"; ctx.fillStyle = "#fde68a"; ctx.font = "900 44px sans-serif"; ctx.fillText("ROYAL LAKSHMI", W / 2, 300);
  ctx.fillStyle = "#a7f3d0"; ctx.font = "700 34px sans-serif"; ctx.fillText("PAYOUT RECEIPT · பணம் அனுப்பப்பட்டது", W / 2, 350);
  // amount pill
  ctx.fillStyle = "#fff"; ctx.shadowColor = "rgba(0,0,0,.45)"; ctx.shadowBlur = 30; rr(ctx, 140, 420, W - 280, 250, 40); ctx.fill(); ctx.shadowBlur = 0;
  ctx.strokeStyle = "#34d399"; ctx.lineWidth = 8; rr(ctx, 140, 420, W - 280, 250, 40); ctx.stroke();
  ctx.fillStyle = "#065f46"; ctx.font = "700 36px sans-serif"; ctx.fillText("AMOUNT PAID", W / 2, 480);
  ctx.fillStyle = "#0f172a"; ctx.font = "900 120px sans-serif"; ctx.fillText(inr(w.amount), W / 2, 610);
  // check badge
  ctx.fillStyle = "#10b981"; ctx.beginPath(); ctx.arc(W / 2, 740, 54, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = "#fff"; ctx.lineWidth = 14; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(W / 2 - 24, 742); ctx.lineTo(W / 2 - 4, 764); ctx.lineTo(W / 2 + 30, 716); ctx.stroke();
  // details
  const rows = [["Paid to", `${METHOD[w.method] || w.method} · ${w.destination || ""}`], ["Reference / UTR", w.receipt_note || "—"], ["Paid on", new Date(w.reviewed_at || w.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })], ["Request ID", String(w.id).slice(0, 8).toUpperCase()]];
  ctx.textAlign = "left";
  rows.forEach(([k, v], i) => {
    const y = 860 + i * 100;
    ctx.fillStyle = "rgba(255,255,255,.08)"; rr(ctx, 100, y - 50, W - 200, 84, 22); ctx.fill();
    ctx.fillStyle = "#a7f3d0"; ctx.font = "700 26px sans-serif"; ctx.fillText(k.toUpperCase(), 130, y - 12);
    ctx.fillStyle = "#fff"; ctx.font = "800 32px sans-serif";
    let txt = String(v); while (ctx.measureText(txt).width > W - 280 && txt.length > 6) txt = txt.slice(0, -2) + "…";
    ctx.fillText(txt, 130, y + 24);
  });
  ctx.textAlign = "center"; ctx.fillStyle = "#fcd34d"; ctx.font = "700 30px sans-serif"; ctx.fillText("Fast payouts · UPI · Bank · GPay · QR", W / 2, H - 110);
  ctx.fillStyle = "rgba(255,255,255,.7)"; ctx.font = "600 26px sans-serif"; ctx.fillText(window.location.origin.replace(/^https?:\/\//, ""), W / 2, H - 65);
  return cv.toDataURL("image/png");
}

export async function shareReceiptCard(w) {
  const text = `✅ ROYAL LAKSHMI payout received!\n${inr(w.amount)} → ${w.destination}\nRef: ${w.receipt_note || "-"}\n\nPlay & win: ${window.location.origin}`;
  try {
    const url = await renderReceiptCard(w);
    const blob = await (await fetch(url)).blob();
    const file = new File([blob], `royal-laxmi-receipt-${String(w.id).slice(0, 8)}.png`, { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], text }); return; }
    const a = document.createElement("a"); a.href = url; a.download = file.name; a.click();
    toast.success("Receipt image saved — attach it in WhatsApp");
  } catch { /* fall through to text */ }
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}

export async function downloadReceiptCard(w) {
  const url = await renderReceiptCard(w);
  const a = document.createElement("a"); a.href = url; a.download = `royal-laxmi-receipt-${String(w.id).slice(0, 8)}.png`; a.click();
  toast.success("Receipt saved to your gallery / downloads");
}
